import { render, staticRenderFns } from "./campusGroup.vue?vue&type=template&id=6b2cdecc&lang=true&"
import script from "./campusGroup.vue?vue&type=script&lang=js&"
export * from "./campusGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports